module.exports = __webpack_public_path__ + "static/logo-asiaLogistic-d56bae72b903b91377d5f22e1fc6dc91.svg";